import React, { FC } from "react";
import { useNavigate } from "react-router";
import { NameOfChildRoutes } from "@shared/constants";

// Relative, not through the "@containers/Recognition/components" barrel: this file lives inside the
// tree that barrel exports, so importing CardHead through it would cycle back to this very file. A
// relative path to a sibling under components/ also costs its consumers nothing at test time — jest
// resolves no path aliases here, so an aliased import would make every suite that mounts this head
// virtual-mock CardHead just to render it.
import { CardHead } from "../../CardHead";

// page-header-promotion-plan.md: the page-level "Recognitions" title, count total and InputSearch that
// used to live here were promoted up into RecognitionsHeader (rendered once, above the tab bar, on
// every tab) — none of that comes back in this change.
//
// This block's head is now the shared SPARK/CardHead (Figma 9380:1302) in its `link` variant: a
// block-scoped title plus a "See all" that navigates to the dedicated screen.
//
// 🚨 The Week/Month/Quarter/All-time period toggle that used to sit here is GONE — pavel, 2026-09-18,
// on being shown it: "You can drop these." The designed head has no slot for it (title, rule, and a
// right slot that is a link, a caption, or nothing), and this block is now a five-row preview rather
// than a feed to filter. Real filtering lives on the dedicated screen, by core value.
//
// Nothing else set `period` on the recognitions filters, so `changePeriod`, the props that carried it,
// and RecognitionList's own `isPeriodWindowed` branch went with it rather than being left as a
// condition no viewer can reach.
interface RecognitionListHeaderProps {
  // Carried into the See-all link so the Received/Sent tab survives the navigation — without it,
  // "See all" from the Sent tab silently lands on Received.
  activeTab?: number;
}

const RecognitionListHeader: FC<RecognitionListHeaderProps> = (props) => {
  const { activeTab } = props;
  const navigate = useNavigate();

  const goToAllRecognitions = () => {
    navigate(`${NameOfChildRoutes.RECOGNITIONS.ROOT}${NameOfChildRoutes.RECOGNITIONS.ALL}?activeTab=${activeTab ?? 0}`);
  };

  return (
    <CardHead
      title="Recent recognitions"
      slot={{ kind: "link", label: "See all", onClick: goToAllRecognitions }}
      className="recognition-list-header"
    />
  );
};

export default RecognitionListHeader;
